import styled from 'styled-components'
import { colors, theme } from '../../../theme/Global'

export const StyledDialogTitle = styled.div`
    color: white;
    font-size: 18px;
    height: 40px;
    padding: 10px 24px;
    display: flex;
    align-items: center; /* Vertically centers the content */
    justify-content: space-between; /* Aligns items to the left and right */
    background-color: ${colors.govDocsBlue};

    && h6 {
        color: ${theme.colors.whiteText};
    }
`

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
`

export const StyledDialogContent = styled.div`
    overflow-y: auto;
    min-height: 150px;
    height: 150px;
    max-height: 300px;
    max-width: 380px;
    padding: 16px 24px 16px 24px;
    flex-direction: row;
    background-color: ${colors.white};

    @media (max-width: 768px) {
        height: auto; /* Adjust height for smaller screens */
    }
`

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: center; /* Horizontally centers the button */
    width: 100%;
    padding-top: 20px;
`
